import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

interface Options {
  drsId: string,
  roleId: string,
  comments?: string,
  projectRevenue?: number,
  planProjectRevenue?: number,
}

export const apiDRSProfitabilityUpdate = ({
  drsId,
  roleId,
  comments,
  projectRevenue,
  planProjectRevenue,
}: Options) => {
  const data: any = {};

  if (comments !== undefined) {
    data.comments = comments;
  }

  if (projectRevenue !== undefined) {
    data.projectRevenue = projectRevenue;
  }

  if (planProjectRevenue !== undefined) {
    data.planProjectRevenue = planProjectRevenue;
  }

  const options = {
    method: 'PUT',
    url: `${BASE_API_URL}/drs/${drsId}`,
    params: {
      role: roleId,
      reqDev: 'web',
    },
    data,
  }
  return ax(options)
}
